import { render, staticRenderFns } from "./CancellationPolicies.vue?vue&type=template&id=553d8571&"
import script from "./CancellationPolicies.vue?vue&type=script&lang=js&"
export * from "./CancellationPolicies.vue?vue&type=script&lang=js&"
import style0 from "./CancellationPolicies.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports